import './DonationThanks.scss'

import {PageData, WysiwygType} from '../../types'

import {BoxBlock} from '../blocks/BoxBlock'
import {Breadcrumbs} from '../layout/Breadcrumbs'
import {Hero} from '../layout/Hero'
import {Layout} from '../layout/Layout'
import React from 'react'
import {Theme} from '../Theme'
import {style} from '../../util/style'
import {wrap} from '@codeurs/front'

type DonationThanksType = {
	team?: {
		id: number | null
		name: string | null
	}
	action?: {
		id: number | null
		name: string | null
	}
	thanks: {
		title: string
		text: WysiwygType
	}
}

const styles = style('donationthanks', ['thanks'])

export const DonationThanks: React.FC<PageData & DonationThanksType> = wrap(
	Layout
)(({title, hero, parents, thanks, team, action, ...props}) => (
	<div className={styles()}>
		<Hero {...hero} title={(hero && hero.title) || title} />
		<Breadcrumbs parents={parents} title={title} />
		<Theme.Container>
			<Thanks action={action} team={team} thanks={thanks} />
		</Theme.Container>
	</div>
))

const Thanks: React.FC<DonationThanksType> = ({team, action, thanks}) => (
	<div className={styles.thanks()}>
		<BoxBlock
			markedtitle={action.name || team.name}
			title={thanks.title}
			text={thanks.text}
		/>
	</div>
)
